export default {
  'Image': '圖片',
  'Text': '文字',
  'Add image': '添加圖片',
  'Opacity': '不透明度',
  "Add text": '添加文字',
  'Text Color': '文字顏色',
  'Outline': '外框',
  'Background': '背景',
  'Text here': '在這裡輸入文字',
}